/**
 * @file 属性值配置
 * @author liuhanwei
 */
// status映射颜色
export const statusColorMap = {
    active: '#2468F2',
    error: '#F33E3E',
    success: '#30BF13'
};
// size映射比例
export const sizeRatioMap = {
    small: 1,
    middle: 2,
    large: 3
};
export function isHexColor(color) {
    return /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/.test(color);
}
;
export function isNumber(num) {
    return !isNaN(num) && num && num !== ' ' || num === 0;
}
;
